export default __webpack_public_path__ + "static/media/stakedSvg.d509f57f.svg";